const Sport_Padel_JSON = {
   sport_name: 'Padel',
   sport_initial: 'PA',
   setup: {
      text_to_speech: { name: 'text_to_speech', value: true, },
      players_to_win_by: { name: 'players_to_win_by', value: true, },
      // { clock: { id: 'game_clock' ,dep: [{ match_options: 1 }] }  }
   },
   settings: {
      event_type: {
         name: 'event_type',
         label: 'Event Type',
         hidden: true,
         type: 'radio',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'default', data_type: 'setting', value: 1
         },
         data_type: 'int',
         value: 0,
         dep: [],
         options: [
            { label: 'Quick Match', value: 0 },
            { label: 'Groups', value: 1 },
         ],
         jsx: 'RadioSetting',
      },
      match_type: {
         name: 'match_type',
         label: 'Match Type',
         type: 'radio',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'match_type'],
            fun: 'match_type',
         },
         data_type: 'int',
         value: 2,
         dep: [],
         options: [
            { label: 'Singles', value: 1 },
            { label: 'Doubles', value: 2 },
         ],
         jsx: 'RadioSetting',
         hide_from_mod: true,
      },
      players: {
         group: {
            player_a: {
               name: 'player_a',
               label: 'Player A',
               placeholder: 'Player A',
               type: 'text',
               special_type: 'player',
               link: { type: 'player', value: 1 },
               data_link: {
                  type: 'mapped',
                  data_type: 'player',
                  value: ['loaded_match', 'player_a_id'],
                  sub_values: [
                     { type: 'mapped', data_type: 'player_replace_id', value: ['loaded_match', 'override_code_1'], },
                     { type: 'mapped', data_type: 'player_replace_name', value: ['loaded_match', 'override_name_1'], }
                  ],
                  fun: 'get_player'
               },
               data_type: 'string',
               value: '',
               sub_value: { name: 'player_a_color', value: '#ff0000', type: 'player_color' },
               dep: [],
               validation: [{ type: 'un_set', value: 'Player A' }],
               jsx: 'PlayerSettings',
            },
            player_c: {
               name: 'player_c',
               placeholder: 'Partner A',
               label: '',
               type: 'text',
               special_type: 'player',
               link: { type: 'player', value: 1 },
               data_link: {
                  type: 'mapped',
                  data_type: 'player',
                  value: ['loaded_match', 'player_c_id'],
                  sub_values: [
                     { type: 'mapped', data_type: 'player_replace_id', value: ['loaded_match', 'override_code_3'], },
                     { type: 'mapped', data_type: 'player_replace_name', value: ['loaded_match', 'override_name_3'], }
                  ],
                  fun: 'get_player'
               },
               data_type: 'string',
               value: '',
               sub_value: { name: 'player_c_color', value: '#ff00b2', type: 'player_color' },
               dep: [{ match_type: 2 }],
               validation: [{ type: 'un_set', value: 'Player C' }],
               jsx: 'PlayerSettings',
            },
            player_b: {
               name: 'player_b',
               label: 'Player B',
               placeholder: 'Player B',
               type: 'text',
               special_type: 'player',
               link: { type: 'player', value: 2 },
               data_link: {
                  type: 'mapped',
                  data_type: 'player',
                  value: ['loaded_match', 'player_b_id'],
                  sub_values: [
                     { type: 'mapped', data_type: 'player_replace_id', value: ['loaded_match', 'override_code_2'], },
                     { type: 'mapped', data_type: 'player_replace_name', value: ['loaded_match', 'override_name_2'], }
                  ],
                  fun: 'get_player'
               },
               data_type: 'string',
               value: '',
               sub_value: { name: 'player_b_color', value: '#00d8ff', type: 'player_color' },
               dep: [],
               validation: [{ type: 'un_set', value: 'Player B' }],
               jsx: 'PlayerSettings',
            },
            player_d: {
               name: 'player_d',
               placeholder: 'Partner B',
               label: '',
               type: 'text',
               special_type: 'player',
               link: { type: 'player', value: 2 },
               data_link: {
                  type: 'mapped',
                  data_type: 'player',
                  value: ['loaded_match', 'player_d_id'],
                  sub_values: [
                     { type: 'mapped', data_type: 'player_replace_id', value: ['loaded_match', 'override_code_4'], },
                     { type: 'mapped', data_type: 'player_replace_name', value: ['loaded_match', 'override_name_4'], }
                  ],
                  fun: 'get_player'
               },
               data_type: 'string',
               value: '',
               sub_value: { name: 'player_d_color', value: '#00ff00', type: 'player_color' },
               dep: [{ match_type: 2 }],
               validation: [{ type: 'un_set', value: 'Player D' }],
               jsx: 'PlayerSettings',
            },
         }
      },
      match_options: {
         name: 'match_options',
         label: 'Match Options',
         type: 'radio',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_1'],
            default: 1,
            convert_table: [
               { value: 1, new_val: 1 },
               { value: 2, new_val: 2 },
               { value: 3, new_val: 3 },
            ],
            fun: null
         },
         data_type: 'int',
         value: 1,
         dep: [],
         options: [
            { label: 'Time Based', value: 3 },
            { label: 'Point Based', value: 2 },
            { label: 'Standard', value: 1 },
         ],
         jsx: 'RadioSetting',
      },
      
      per_point_scoring: {
         name: 'per_point_scoring',
         label: 'Per Point Scoring',
         type: 'radio',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_2'],
            fun: null
         },
         data_type: 'int',
         value: 0,
         dep: [{ match_options: 1 },],
         options: [
            { label: 'Yes', value: 1 },
            { label: 'No', value: 0 },
         ],
         jsx: 'RadioSetting',
      },
      play_advantage: {
         name: 'play_advantage',
         label: 'Play Advantage',
         type: 'radio',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_3'],
            fun: null
         },
         data_type: 'int',
         value: 1,
         dep: [{ match_options: 1 }, { per_point_scoring: 1 }],
         options: [
            { label: 'Yes', value: 1 },
            { label: 'No', value: 0 },
         ],
         jsx: 'RadioSetting',
      },

      advantage_config: {
         name: 'advantage_config',
         label: 'Advantage Configuration',
         type: 'radio',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_10'],
            fun: null
         },
         data_type: 'int',
         value: 0,
         dep: [{ match_options: 1 }, { per_point_scoring: 1 }, { play_advantage: 1 }],
         options: [
            { label: 'All', value: 0 },
            { label: 'Second', value: 1 },
            { label: 'Third', value: 2 },
         ],
         jsx: 'RadioSetting',
      },

      points_per_game: {
         name: 'points_per_game',    // games_set
         label: 'Games per Set',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'game_points'],
            fun: null
         },
         data_type: 'int',
         value: 6,
         dep: [{ match_options: 1 },],
         // fun: [],
         // validation: [],
         jsx: 'InputCountSetting',
      },      
      // >>>>>>>>>> sets_match <<<<<<<<<<<
      games_per_match: {   // sets_match
         name: 'games_per_match',
         label: 'Sets Per Match',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'best_of'],
            fun: null
         },
         data_type: 'int',
         value: 3,
         dep: [{ match_options: 1 }],
         jsx: 'InputCountSetting',
      },
      tb_points: {
         name: 'tb_points',
         label: 'Tie Break Points',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_9'],
            fun: null
         },
         data_type: 'int',
         value: 7,
         // dep: [{ match_options: 1 }, { type: 'game_setting_is_greater', sub_type: 'games_per_match', value: 1 }],
         dep: [{ match_options: 1 }],
         // fun: [],
         // validation: [],
         jsx: 'InputCountSetting',
      },
      tb_trigger: {
         name: 'tb_trigger',
         label: 'Tie Break Game Trigger',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_8'],
            fun: null
         },
         data_type: 'int',
         value: 6,
         // dep: [{ match_options: 1 }, { type: 'game_setting_is_greater', sub_type: 'games_per_match', value: 1 }],
         dep: [{ match_options: 1 }],
         validation: [{ type: 'must_be_lesser_or_equal_to_setting', setting: 'points_per_game', message: 'Games per Set must be greater or equal to Tie Break Game Trigger' }],
         // validation: [],
         jsx: 'InputCountSetting',
      },
      deciding_match: { /// deciding_set
         name: 'deciding_match',
         label: 'Deciding Set',
         type: 'radio',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_4'],
            fun: null
         },
         data_type: 'int',
         value: 1,
         // dep: [{ match_options: 1 }, { type: 'game_setting_is_greater', sub_type: 'games_per_match', value: 1 }],
         // dep: [{ match_options: 1 }],
         dep: [{ match_options: 1 }, { type: 'game_setting_is_greater', sub_type: 'games_per_match', value: 1 }],
         fun: [{ type: 'set_default', value: [{ setting: 'ds_tb_points', value: 1, default: 7 }, { setting: 'ds_tb_points', value: 2, default: 10 }] }],
         options: [
            { label: 'Tie Break Set', value: 1 },
            { label: 'Super Tie Break', value: 2 },
            { label: 'Long Set', value: 3 },
         ],
         jsx: 'RadioSetting',
         jsx_classes: ['font_italic'],
      },
      
      ds_games_set: {
         name: 'ds_games_set',
         label: 'Games per Set:',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_7'],
            fun: null
         },
         data_type: 'int',
         value: 6,
         dep: [ { match_options: 1 },{ deciding_match: 1 }, { type: 'game_setting_is_greater', sub_type: 'games_per_match', value: 1 }],
         jsx: 'InputCountSetting',
         jsx_classes: ['left_grouping', 'font_italic'],
      },

      ds_tb_points: {
         name: 'ds_tb_points',
         label: 'Tie Break Points',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_5'],
            fun: null
         },
         data_type: 'int',
         value: 7,
         dep: [{ match_options: 1 }, { type: 'game_setting_is_lesser', sub_type: 'deciding_match', value: 3 }, { type: 'game_setting_is_greater', sub_type: 'games_per_match', value: 1 }],
         jsx: 'InputCountSetting',
         jsx_classes: ['left_grouping', 'font_italic'],
      },
      ds_tb_trigger: {
         name: 'ds_tb_trigger',
         label: 'Tie Break Game Trigger:',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'sport_option_6'],
            fun: null
         },
         data_type: 'int',
         value: 6,
         dep: [{ match_options: 1 },  { deciding_match: 1 }, { type: 'game_setting_is_greater', sub_type: 'games_per_match', value: 1 }],
         validation: [{ type: 'must_be_lesser_or_equal_to_setting', setting: 'ds_games_set', message: 'Games per Set must be greater or equal to Tie Break Game Trigger' }],
         jsx: 'InputCountSetting',
         jsx_classes: ['left_grouping'],
      },

      pb_points: {
         name: 'pb_points',
         label: 'Points',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'game_points'],
            fun: null
         },
         data_type: 'int',
         value: 21,
         dep: [{ match_options: 2 },],
         // fun: [],
         // validation: [],
         jsx: 'InputCountSetting',
      },
      win_by: {
         name: 'win_by',
         label: 'Win By',
         type: 'radio',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'win_by'],
            fun: 'win_by'
         },
         data_type: 'int',
         value: 2,
         dep: [{ match_options: 2 }],
         options: [
            { label: '1 Point', value: 1 },
            { label: '2 Points', value: 2 },
         ],
         jsx: 'RadioSetting',
      },

      continuous_time: {
         name: 'continuous_time',
         label: 'Time: (mins)',
         type: 'number',
         link: { type: 'scoring', value: null },
         data_link: {
            type: 'mapped',
            data_type: 'setting',
            value: ['loaded_match', 'continuous_timer'],
            fun: null
         },
         data_type: 'int',
         value: 20,
         dep: [{ match_options: 3 }],
         jsx: 'InputCountSetting',
      },
      continuous_options: {
         name: 'continuous_options',
         label: 'Additional Options',
         type: 'radio',
         link: { type: 'scoring', value: null },
         // data_link: { // For linking to loaded_match table
         //    type: 'mapped', 
         //    data_type: 'setting',
         //    value: ['loaded_match','continuous_timer'],
         //    fun: null
         // },
         data_type: 'int',
         value: 0,
         dep: [{ match_options: 3 }, { type: 'free_app', value: false }],
         options: [
            { label: 'OFF', value: 0 },
            { label: '10 Points', value: 1 },
            { label: 'Swap Scores', value: 2 },
         ],
         jsx: 'RadioSetting',
      },
   },

   scoring: {
      sides: 2,
      scoring_type: 'tennis', // 'standard',
      serving_type: 'tennis',
      game_clock: {
         id: 'game_clock',
         type: 'setTimer',
         value: 0,
         trigger: 1,
         dep: [{ type: 'game_settings', sub_type: 'match_options', value: 1 }],
         action: null,
      },
      continuous_clock: {
         id: 'continuous_clock',
         // type: 'setTimer',
         // value: 20,
         // init_value: 'time',
         // trigger: 1,
         // reverse: true,
         dep: [{ type: 'game_settings', sub_type: 'match_options', value: 2 }],
         // action: null,
      },

      serving: {
         doubles_helper: { value: true, type: 'initial' },
         single_helper: { value: true, type: 'icon' },
         handout: { value: 1, type: 'point' },
         handout_default: { value: 2, type: 'side' },
         change_server: { value: 1, type: 'point' },
         server_default: { value: 1, type: 'side' },
         // serving_type: { type: 'standard', value: 1 },
         user_preference: { type: 'standard', value: 1 },
         player_position: { type: 'standard', value: 1 },
         hide_server_indicator: { type: 'standard', value: true },

      },
      tool_block: [
         {
            pos: 2,
            hidden: false,
            jsx: {
               text: 'Score Sheet',
               icon: 'faBinoculars',
               type: 'standard',
            },
            fun: [{ type: 'nav', value: 'open_right_menu', }, { type: 'nav', value: 'open_scoresheet', }],
         },
         {
            pos: 5,
            hidden: false,
            dep: [{ type: 'current_game_total_logs', value: 0 }],
            jsx: {
               text: 'Play',
               icon: 'faPlay',
               type: 'standard',
            },
            fun: { type: 'speechFun', value: 'play_button_tennis', },
         },
         {
            pos: 5,
            hidden: false,
            dep: [{ type: 'current_game_total_logs_greater', value: 0 }],
            jsx: {
               text: 'Undo',
               icon: 'faArrowRotateLeft',
               type: 'standard',
            },
            fun: { type: 'score_undo', value: '', },
         },
         // {
         //    pos: 8,
         //    hidden: false,
         //    // dep: [{ type: 'team_1_score_not', value: 0 }, { type: 'team_2_score_not', value: 0 }, { type: 'serve_inner_changed', value: true }],
         //    dep: [{ type: 'serve_inner_changed', value: true }],
         //    jsx: {
         //       text: 'Save Side',
         //       icon: 'faFloppyDisk',
         //       type: 'standard',
         //    },
         //    fun: { type: 'save_serving_defaults', value: '', },
         // },
         {
            pos: 8,
            hidden: false,
            dep: [{ type: 'current_game_total_logs', value: 0 }, { type: 'game_count', value: 1 }],
            jsx: {
               text: 'Warm-up',
               icon: 'faPersonRunning',
               type: 'standard',
            },
            fun: { type: 'screenFun', value: 'warmup', },
         },
         {
            pos: 8,
            hidden: false,
            jsx: {
               text: 'Swap',
               icon: 'faRightLeft',
               type: 'standard',
            },
            fun: { type: 'swap_score_screen', value: 0, },
         },
         {
            pos: 8,
            hidden: false,
            dep: [{ type: 'game_settings', value: { type: 'match_options', value: 2 } }, { type: 'clock', value: { type: 'continuous_clock', value: 0 } },],
            jsx: {
               text: 'End Game',
               icon: 'faHand',
               type: 'standard',
            },
            fun: { type: 'end_match_confirm', value: 0, },
         },
         {
            pos: 8,
            hidden: false,
            dep: [{ type: 'game_settings', value: { type: 'continuous_options', value: 1 } }, { type: 'continuous_10_points', value: true },],
            jsx: {
               text: '10 Points',
               icon: 'faCirclePlus',
               type: 'standard',
            },
            fun: { type: 'add_10_points_continuous', value: 0, },
         },
         {
            pos: 8,
            hidden: false,
            dep: [{ type: 'game_settings', value: { type: 'continuous_options', value: 2 } }, { type: 'has_log', value: { type: 'swap-score', value: 0 } }],
            jsx: {
               text: 'Swap Score',
               icon: 'faRepeat',
               type: 'standard',
               class: 'Btn_tool_grayed',
            },
            fun: { type: 'null', value: 0, },
         },
         {
            pos: 8,
            hidden: false,
            dep: [{ type: 'game_settings', value: { type: 'continuous_options', value: 2 } }],
            jsx: {
               text: 'Swap Score',
               icon: 'faRepeat',
               type: 'standard',
            },
            fun: { type: 'reverse_score_continuous', value: 0, },
         },
      ],
   },
   warmup: {
      setup: [
         { clock: { id: 'warmup_timer' } }
      ],
      tool_block: [
         {
            pos: 4,
            hidden: false,
            jsx: {
               text: '3 Min Start',
               icon: 'faArrowRotateLeft',
               type: 'standard',
            },
            fun: {
               type: 'setTimer',
               value: {
                  trigger: 1,
                  value: 180,
                  reverse: true,
                  id: 'warmup_timer',
                  action: [{
                     value: 0,
                     fun: { type: 'startMatch', value: '', }
                  },
                  {
                     value: 120,
                     fun: { type: 'speech', value: '2 Minutes, Remaining', }
                  },
                  ]
               }
            },
         },
         {
            pos: 5,
            hidden: false,
            jsx: {
               text: 'Play',
               icon: 'faPlay',
               type: 'standard',
            },
            fun: [{ type: 'startMatch', value: 0 }],
         },
         {
            pos: 6,
            hidden: false,
            jsx: {
               text: 'Change Sides',
               icon: 'faArrowsRotate',
               type: 'standard',
            },
            fun: { type: 'sideSwap', value: 0 },
         },
         {
            pos: 8,
            hidden: false,
            jsx: {
               text: '',
               icon: 'cast_btn',
               type: 'standard',
               class: 'Btn_toolClear'
            },
            fun: [
               { type: 'cast_btn', value: '' },
            ],
         },
         {
            pos: 9,
            hidden: false,
            jsx: {
               text: 'Check',
               icon: 'faVolumeHigh',
               type: 'standard',
               class: 'Btn_toolClear'
            },
            fun: [
               { type: 'sounds_test', value: '' },
            ],
         },
      ],
   },
   between_games: {
      setup: [
         { clock: { id: 'between_timer' } }
      ],
      tool_block: [
         {
            pos: 4,
            hidden: false,
            dep: [{ type: 'game_state', value: 'game_complete' }],
            jsx: {
               text: '90 Seconds',
               icon: '',
               type: 'standard',
            },
            fun: [
               {
                  type: 'setTimer', value: {
                     trigger: 1,
                     value: 90,
                     reverse: true,
                     id: 'between_timer',
                     action: [{
                        value: 0,
                        fun: { type: 'startMatch', value: '', }
                     },
                     {
                        value: 15,
                        fun: { type: 'speech', value: '15 Seconds, Remaining', }
                     },
                     ],
                  }
               },
               { type: 'speech', value: '90, seconds', }
            ],
         },
         {
            pos: 6,
            hidden: false,
            dep: [{ type: 'game_state', value: 'game_complete' }],
            jsx: {
               text: '120 Seconds',
               icon: '',
               type: 'standard',
            },
            fun: [
               {
                  type: 'setTimer', value: {
                     trigger: 1,
                     value: 120,
                     reverse: true,
                     id: 'between_timer',
                     action: [
                        {
                           value: 0,
                           fun: { type: 'startMatch', value: '', }
                        },
                        {
                           value: 15,
                           fun: { type: 'speech', value: '15 Seconds, Remaining', }
                        },
                     ]
                  }
               },
               { type: 'speech', value: '120, seconds', }
            ],
         },
         {
            pos: 5,
            hidden: false,
            dep: [{ type: 'game_state', value: 'game_complete' }],
            jsx: {
               text: 'Resume Match',
               icon: '',
               type: 'standard',
            },
            fun: { type: 'startMatch', value: 0 },
         },
         {
            pos: 5,
            hidden: false,
            dep: [{ type: 'game_state', value: 'match_complete' }],
            jsx: {
               text: 'New Match',
               icon: '',
               type: 'standard',
            },
            fun: { type: 'completeMatch', value: 0 },
         },

         {
            pos: 4,
            hidden: false,
            dep: [{ type: 'game_state', value: 'end_game_pause' }],
            jsx: {
               text: '90 Seconds',
               icon: '',
               type: 'standard',
            },
            fun: [
               {
                  type: 'setTimer', value: {
                     trigger: 1,
                     value: 90,
                     reverse: true,
                     id: 'between_timer',
                     action: [{
                        value: 0,
                        fun: { type: 'resumeMatch', value: '', }
                     },
                     {
                        value: 15,
                        fun: { type: 'speech', value: '15 Seconds, Remaining', }
                     },
                     ],
                  }
               },
               { type: 'speech', value: '90, seconds', }
            ],
         },
         {
            pos: 6,
            hidden: false,
            dep: [{ type: 'game_state', value: 'end_game_pause' }],
            jsx: {
               text: '120 Seconds',
               icon: '',
               type: 'standard',
            },
            fun: [
               {
                  type: 'setTimer', value: {
                     trigger: 1,
                     value: 120,
                     reverse: true,
                     id: 'between_timer',
                     action: [
                        {
                           value: 0,
                           fun: { type: 'resumeMatch', value: '', }
                        },
                        {
                           value: 15,
                           fun: { type: 'speech', value: '15 Seconds, Remaining', }
                        },
                     ]
                  }
               },
               { type: 'speech', value: '120, seconds', }
            ],
         },
         {
            pos: 5,
            hidden: false,
            dep: [{ type: 'game_state', value: 'end_game_pause' }],
            jsx: {
               text: 'Resume Match',
               icon: '',
               type: 'standard',
            },
            fun: { type: 'resumeMatch', value: 0 },
         },
      ],
   },
   game_menu: {
      tool_block: [
         {
            pos: 1,
            hidden: false,
            jsx: {
               text: 'Cheeky',
               icon: 'faFaceGrinTongueWink',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: {
               type: 'sub_menu',
               value: null,
               options: [
                  {
                     jsx: {
                        text: 'Quiet please!',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Quiet please!' },
                  },
                  {
                     jsx: {
                        text: 'New balls please!',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'New balls please!' },
                  },
                  {
                     jsx: {
                        text: 'Player challenging the call on sideline. Ball was called OUT!',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Player challenging the call on sideline. Ball was called OUT!' },
                  },
                  {
                     jsx: {
                        text: 'Fault. Correction!',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Fault. Correction!' },
                  },
                  {
                     jsx: {
                        text: "Language violation",
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: "Language violation" },
                  },
                  {
                     jsx: {
                        text: 'Fantastic Rally',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Fantastic Rally' },
                  },
                  {
                     jsx: {
                        text: 'Please remain seated whilst game is in play',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Please remain seated whilst game is in play' },
                  },
                  {
                     jsx: {
                        text: 'A tweener! Thought only Federer could do that!',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'A tweener! Thought only Federer could do that!' },
                  },
               ]
            },
         },
         {
            pos: 2,
            hidden: false,
            jsx: {
               text: 'Referee',
               icon: 'faTriangleExclamation',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: {
               type: 'sub_menu',
               value: null,
               options: [
                  {
                     jsx: {
                        text: 'Conduct Warning',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Conduct Warning' },
                  },
                  {
                     jsx: {
                        text: 'Conduct Point',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Conduct Point' },
                  },
                  {
                     jsx: {
                        text: 'Conduct Game',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Conduct Game' },
                  },
                  {
                     jsx: {
                        text: 'Conduct Set',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Conduct Set' },
                  },
                  {
                     jsx: {
                        text: 'Conduct Match',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Conduct Match' },
                  },
                  {
                     jsx: {
                        text: 'Time Violation',
                        icon: '',
                        type: 'standard',
                     },
                     fun: { type: 'speech', value: 'Time Violation' },
                  },
               ]
            },
         },
         {
            pos: 3,
            hidden: false,
            jsx: {
               text: 'Let',
               icon: 'faHandPointer',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: [
               { type: 'speech', value: 'Let' },
               { type: 'log', value: '(Let)' },
            ],
         },
         {
            pos: 4,
            hidden: false,
            jsx: {
               text: 'No Let',
               icon: 'faHandSpock',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: [
               { type: 'speech', value: 'No Let' },
               { type: 'log', value: '(No Let)' },
            ],
         },
         {
            pos: 5,
            hidden: false,
            jsx: {
               text: 'Good',
               icon: 'faThumbsUp',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: [
               { type: 'speech', value: 'Good' },
               { type: 'log', value: '(Good)' },
            ],
         },

         {
            pos: 5,
            hidden: false,
            jsx: {
               text: 'Fault',
               icon: 'faThumbsDown',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: [
               { type: 'speech', value: 'Fault' },
               { type: 'log', value: '(Fault)' },
            ],
         },
         {
            pos: 5,
            hidden: false,
            jsx: [
               {
                  text: 'Mute',
                  icon: 'faVolumeHigh',
                  type: 'standard',
                  class: 'Btn_toolSolid',
                  dep: [{ type: 'settings_mute', value: false }],
               },
               {
                  text: 'Mute',
                  icon: 'faVolumeXmark',
                  type: 'standard',
                  class: 'Btn_toolSolid',
                  dep: [{ type: 'settings_mute', value: true }],

               }
            ],
            fun: [
               { type: 'mute', value: '' },
            ],
         },
         {
            pos: 5,
            hidden: false,
            jsx: {
               text: 'Repeat',
               icon: 'faRotateRight',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: [
               { type: 'Repeat', value: '' },
            ],
         },
         // {
         //    pos: 5,
         //    hidden: false,
         //    jsx: {
         //       text: 'Stopwatch',
         //       icon: 'faStopwatch',
         //       type: 'standard',
         //       class: 'Btn_toolSolid'
         //    },
         //    fun: [
         //       { type: 'Stopwatch', value: '' },
         //    ],
         // },
         // {
         //    pos: 5,
         //    hidden: false,
         //    jsx: {
         //       text: 'Alert TC',
         //       icon: 'faBell',
         //       type: 'standard',
         //       class: 'Btn_toolSolid'
         //    },
         //    fun: [
         //       { type: 'tc_alert', value: '' },
         //    ],
         // },
         {
            pos: 5,
            hidden: false,
            jsx: {
               text: 'End Match',
               icon: 'faCircleStop',
               type: 'standard',
               class: 'Btn_toolSolid'
            },
            fun: [
               { type: 'end_match', value: '' },
            ],
         },
      ]
   },
   settings_menu: { tool_block: [] },
   clocks: [
      {
         id: 'game_clock',
         type: 'setTimer',
         value: 0,
         trigger: 1,
         action: null,
         reverse: false,
      },
      {
         id: 'continuous_clock',
         type: 'setTimer',
         value: 0,
         init_value: { type: 'game_setting', value: 'continuous_time' },
         trigger: 1,
         reverse: true,
         action: {
            value: 0,
            fun: 'update_game_state_timestamp',
         }
      },
      {
         id: 'warmup_timer',
         type: 'setTimer',
         trigger: 1,
         value: 0,
         reverse: true,
         action: {
            value: 0,
            fun: 'startMatch',
         }
      },
      {
         id: 'between_timer',
         type: 'setTimer',
         trigger: 1,
         value: 0,
         reverse: true,
         action: {
            value: 0,
            fun: 'startMatch',
         }
      },
   ],
   hot_keys: {
      keys: [],
      actions: [
         // {
         //    screen: 'scoring_screen',
         //    condition: [ { type: 'team_1_score_not', value: 0 }, { type: 'team_2_score_not', value: 0 } ],
         //    fun: { type: 'speechFun', value: 'play_button_tennis', },
         //    keys: [ 'play_pause'  ],
         // },
      ],
   },
   speech: {
      handout: 'Please Change Sides',
      match_ball: '',
      game_ball: '',
      win_by_call: false,
      game: 'Set',
   }
}

export default Sport_Padel_JSON;